import { Component } from '@angular/core';
import { CommonInfoService } from '../../cart-process/common-info.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { AppInjector } from '../../utils/services/set-app-injector';
import RecaptchaService from './recaptcha.service';
import { FormSectionTypeEnum, FormStepsService } from '../form-steps/form-steps.service';
import { hiddenElementSlideInOut } from '../../utils/animations/slides.animation';

@Component({
  selector: 'recaptcha-component',
  templateUrl: './recaptcha.component.html',
  animations: [hiddenElementSlideInOut],
})
export default class RecaptchaComponent {
  public themeResourcePath: string = window['themeResourcePath'];
  public formSectionTypeEnum: typeof FormSectionTypeEnum = FormSectionTypeEnum;
  public showSection = false;

  private notificationProvider: NotificationProviderService = AppInjector.get(NotificationProviderService);


  constructor(
    private commonInfo: CommonInfoService,
    private recaptchaService: RecaptchaService,
    public formStepsService: FormStepsService,
  ){
    this.showSection = this.commonInfo.isOtherSalesOffer;
    this.notificationProvider.subscribe(NotificationProviderTypeEnum.COMMON_INFO, (_commonInfo: CommonInfoService) => {
      if (_commonInfo) {
        this.showSection = _commonInfo.isOtherSalesOffer;
      }
    });
  }
}
